import Box from '@mui/material/Box';
import { IconButton, colors } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import { HEADER_TOP_ENDORNMENT } from './constants';

interface DocumentationCardShellProps {
  onClose: () => void;
  headerContent?: React.ReactNode;
  children: React.ReactNode;
  color?: string;
}

export const DocumentationCardShell = ({
  onClose,
  headerContent,
  children,
  color,
}: DocumentationCardShellProps) => {
  return (
    <>
      <Box
        sx={{
          background: color || colors.grey[100],
          width: '100%',
          height: HEADER_TOP_ENDORNMENT,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          pr: 1,
          gap: 1,

          //TODO add option to design system
          button: {
            '&:hover': {
              backgroundColor: 'transparent',
              overflow: 'hidden',

              '&:before': {
                content: '""',
                position: 'absolute',
                height: '100%',
                width: '100%',
                backgroundColor: colors.grey[120],
                mixBlendMode: 'soft-light',
                zIndex: '1',
              },
            },
          },
        }}
        data-testid="documentation-card-shell-header"
      >
        {headerContent}
        <Box data-testid="documentation-card-panel-close-button">
          <IconButton variant="flat" size="tiny" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        height={`calc(100% - ${HEADER_TOP_ENDORNMENT})`}
        width="100%"
        overflow="scroll"
      >
        {children}
      </Box>
    </>
  );
};
